"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../constants");
exports.default = theme => ({
    root: {
        appearance: 'none',
        backgroundColor: 'transparent',
        flexShrink: 0,
        boxSizing: 'border-box',
        cursor: 'pointer',
        outline: 'none',
        borderWidth: 1,
        borderStyle: 'solid',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: theme.grey2,
        borderColor: 'transparent',
        opacity: 1,
        transition: 'opacity 250ms linear 250ms',
        '&[aria-busy="true"]': {
            opacity: 0
        },
        '&:focus': {
            backgroundColor: theme.grey7
        },
        '&[aria-expanded="true"]': {
            backgroundColor: 'transparent',
            color: theme.grey2,
            borderColor: theme.grey5
        }
    },
    rootTricolon: {
        width: 18,
        height: 28,
        borderRadius: 2,
        '& > span': {
            flexShrink: 0,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            width: 4,
            height: 18,
            '&::before, &::after': {
                content: '""'
            },
            '&::before, &::after, & > i': {
                display: 'block',
                padding: '50%',
                backgroundColor: 'currentColor',
                borderRadius: '50%'
            }
        }
    },
    rootTricolonSmall: {
        width: 13,
        height: 21,
        '& > span': {
            width: 3,
            height: 13
        }
    },
    rootAvatar: {
        width: props => props.avatarSize || 32,
        height: props => props.avatarSize || 32,
        borderRadius: '50%',
        position: 'relative',
        overflow: 'hidden',
        borderWidth: 0,
        '&:focus, &[aria-expanded="true"]': {
            boxShadow: `0 0 0 ${constants_1.FOCUS_OUTLINE_WIDTH}px ${theme.grey7}`
        },
        '&::after': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            boxShadow: `inset 0px 0px 3px 0px rgba(52, 50, 58, 0.3)`,
            borderRadius: 'inherit'
        },
        '& > span': {
            display: 'block',
            '& > img': {
                display: 'block',
                width: '100%',
                height: 'auto'
            }
        }
    }
});
//# sourceMappingURL=popover.button.style.js.map